import { render, staticRenderFns } from "./TableSortForm.vue?vue&type=template&id=858da5f0&scoped=true"
import script from "./TableSortForm.vue?vue&type=script&lang=js"
export * from "./TableSortForm.vue?vue&type=script&lang=js"
import style0 from "./TableSortForm.vue?vue&type=style&index=0&id=858da5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858da5f0",
  null
  
)

export default component.exports